<template>
  <!-- 班级数据 -->
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="box">
      <!--  -->
      <div class="search">
        <div class="search-gropu">
          课程名称：
          <el-select v-model="course_name" @change="selectChange"  placeholder="请选择课程">
            <el-option v-for="item in bigcourse" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-gropu">
          课程期次：
          <el-select v-model="course" @visible-change="visibleSelectChange" @change="courseSelectChange" placeholder="请选择课程期次">
            <el-option
              v-for="item in period_list"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-gropu on">
          购买时间：
          <el-date-picker
            class="buy-time"
            v-model="buy_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
         
        </div>
        <div class="search-gropu btn">
           <el-button style="margin-left:10px;" type="primary" @click="getTaList('del')" size="medium">查询</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <!-- 总数 -->
        <div class="total">
          <div class="total-node">
            <h2>续报数据</h2>
            <div class="total-main">
              <!-- 学员 -->
              <div class="stu">
                <div class="stu-left">
                  <h4>学员续报人数</h4>
                  <h3>{{statObj.user_reorder_count||statObj.user_reorder_count==0?statObj.user_reorder_count:'--'}}</h3>
                </div>
                <div class="stu-right">
                  <img src="@a/operating/referral_statistics/stu_icon.png" />
                </div>
              </div>
              <!-- 助教 -->
              <div class="ta">
                <div class="ta-left">
                  <h4>助教续报人数含教练</h4>
                  <h3>{{statObj.tutor_reorder_count||statObj.tutor_reorder_count==0?statObj.tutor_reorder_count:'--'}}</h3>
                </div>
                <div class="ta-right">
                  <img src="@a/operating/referral_statistics/ta_icon.png" />
                </div>
              </div>
            </div>
          </div>
          <!-- 转介数据 -->
          <div class="total-node">
            <h2>转介数据</h2>
            <div class="total-main">
              <!-- 学员 -->
              <div class="stu">
                <div class="stu-left">
                  <h4>学员转介人数</h4>
                  <h3>{{statObj.user_referral_count || statObj.user_referral_count==0?statObj.user_referral_count:'--'}}</h3>
                </div>
                <div class="stu-right">
                  <img src="@a/operating/referral_statistics/stu_icon.png" />
                </div>
              </div>
              <!-- 助教 -->
              <div class="ta">
                <div class="ta-left">
                  <h4>助教转介人数含教练</h4>
                  <h3>{{statObj.tutor_referral_count || statObj.tutor_referral_count==0?statObj.tutor_referral_count:'--'}}</h3>
                </div>
                <div class="ta-right">
                  <img src="@a/operating/referral_statistics/ta_icon.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="show">
          <!-- 折线图 -->
          <div class="line-bar">
            <div v-if="!course" class="bar-tools">
              <a :class="[chartObj.bool1==7?'on':'']" @click="screenHandle('bool1',7)">周</a>
              <a :class="[chartObj.bool1==30?'on':'']" @click="screenHandle('bool1',30)">月</a>
            </div>
            <div ref="bool1" id="container" style="height:300px;"></div>
          </div>
          <!--  -->
          <div class="line-bar">
            <div  v-if="!course" class="bar-tools">
              <a :class="[chartObj.bool2==7?'on':'']" @click="screenHandle('bool2',7)">周</a>
              <a :class="[chartObj.bool2==30?'on':'']" @click="screenHandle('bool2',30)">月</a>
            </div>
            <div ref="bool2" id="container2" style="height:300px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Line } from "@antv/g2plot";
import { getDay_ ,dateFormat,getDaysBetween } from "@/utils/tools";
import {
  getStatCount,
  getStatCountResult,
  getCourseList
} from "@/api/operating";
export default {
  data() {
    return {
      list: [],
      pages: {},
      bigcourse: [],
      courseList: [],
      period_list:[],
      course_name: '',
      course: null,
      buy_time: [],
      // 获取总数
      statObj: {},
      // 获取的数据
      data_: {},
      //
      chartObj: {
        bool1: 30,
        bool2: 30
      },
      bool1: true,
      bool2: true,
      show:false,
      // 期次的开始时间和结束时间
      beginTime:'',
      endTime:'',
      // 日期间隔天数
      dayBetween:null
    };
  },
  methods: {
    // 选择期次触发
    courseSelectChange(val){
      for(let i=0;i<this.courseList.length;i++){
        if(this.courseList[i].cid==val){
          this.beginTime = dateFormat('yyyy-MM-dd',new Date(this.courseList[i].course_begintime*1000));
          this.endTime = dateFormat('yyyy-MM-dd',new Date(this.courseList[i].course_endtime*1000));
          break;
        }
      }
    },
    // 点击期次触发
    visibleSelectChange(val) {
      if (!this.course_name) {
        this.$message("请先选择课程！");
        return;
      }
    },
    selectChange(val){
      this.course = null;
      this.period_list = [];
      for(let i=0;i<this.courseList.length;i++){
        if(this.courseList[i].bigcourse==this.course_name){
          this.period_list[this.period_list.length] = {
            id:this.courseList[i].cid,
            name:this.courseList[i].course
          };
        }
      }
    },
    // 点击筛选图表
    screenHandle(type, num) {
      this.chartObj[type] = num;
      this.getTaList(type);
    },
    // 获取数据
    getTaList(type) {
      this.show = false;
      this.$showLoading();
      let obj = {};
      if (this.course) {
        obj["cid"] = this.course;
      }
      // 判断是否选择购买日期
      if (this.buy_time.length > 0) {
        obj["start_date"] = this.buy_time[0]; //开始时间
        obj["end_date"] = this.buy_time[1]; //结束时间
      }else{
        // 判断是否选择期次
        if(this.course){
          obj["start_date"] = this.beginTime; //开始时间
          obj["end_date"] = this.endTime; //结束时间
        }else{
          // type 如果没有数据，默认近30天数据
          obj["start_date"] = getDay_(type?-this.chartObj[type]:-30).replace(/\//g, '-'); //开始时间
          obj["end_date"] = getDay_(0).replace(/\//g, '-'); //结束时间
        }
      }

      getStatCountResult(obj)
        .then(data => {
          this.data_ = data;
          this.chartData(type, obj.start_date, obj.end_date);
          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
      // 获取总数
      getStatCount(obj).then(data => {
        this.statObj = data;
      });
      this.show = true;
    },
    // 处理图表数据
    chartData(type, start, end) {
      let data = this.data_;
      

      let date_list = [];
      let start_time = (new Date(start.replace(/-/g, '/'))).getTime();
      let end_time = (new Date(end.replace(/-/g, '/'))).getTime();
      let date_time = start_time;
      while(date_time <= end_time) {
        date_list.push(dateFormat("yyyy-MM-dd", new Date(date_time)));
        date_time += 3600 * 24 * 1000;
      }

      
      // 续报数据
      let arr = [];
      let user_reorder_result = {};
      let tutor_reorder_result = {};
      let result = data.user_reorder_result;
      let result2 = data.tutor_reorder_result;
      for(let i = 0; i < result.length; i++) {
        user_reorder_result[result[i].date] = result[i];
      }
      for(let i = 0; i < result2.length; i++) {
        tutor_reorder_result[result2[i].date] = result2[i];
      }
      // console.log(date_list);
      for(let i = 0; i < date_list.length; i++) {
        let date = date_list[i];
        let user_reorder_count = user_reorder_result[date] ? user_reorder_result[date].count : 0;
        let tutor_reorder_count = tutor_reorder_result[date] ? tutor_reorder_result[date].count : 0;
        arr.push({
          type: "学员",
          date: date,
          count: user_reorder_count
        });
        arr.push({
          type: "助教",
          date: date,
          count: tutor_reorder_count
        });
        
      }
      // 转介数据
      let arr2 = [];

      let user_referral_result = {};
      let tutor_referral_result = {};
      let result3 = data.user_referral_result;
      let result4 = data.tutor_referral_result;
      for(let i = 0; i < result3.length; i++) {
        user_referral_result[result3[i].date] = result3[i];
      }
      for(let i = 0; i < result4.length; i++) {
        tutor_referral_result[result4[i].date] = result4[i];
      }
      // console.log(date_list);
      for(let i = 0; i < date_list.length; i++) {
        let date = date_list[i];
        let user_referral_count = user_referral_result[date] ? user_referral_result[date].count : 0;
        let tutor_referral_count = tutor_referral_result[date] ? tutor_referral_result[date].count : 0;
        arr2.push({
          type: "学员",
          date: date,
          count: user_referral_count
        });
        arr2.push({
          type: "助教",
          date: date,
          count: tutor_referral_count
        });
        
      }
     
      if (type != undefined || type === 'del') {
        this.deleteChildCHart(type);
        
      }
      if (type == "bool1") {
        this.lineBar(arr, "container", "续报单日数据");
      } else if (type == "bool2") {
        this.lineBar(arr2, "container2", "转介单日数据");
      }else{
        this.lineBar(arr, "container", "续报单日数据");
        this.lineBar(arr2, "container2", "转介单日数据");
      }
    },
    // 删除前一个图表
    deleteChildCHart(type) {
      // 如果是del
      if(type=='del'){
        let arr = ['bool1','bool2'];
        for(let i=0;i<arr.length;i++){
          while (this.$refs[arr[i]].childNodes.length > 0) {
            this.$forceUpdate();
            this.$refs[arr[i]].removeChild(this.$refs[arr[i]].childNodes[0]);
          }
        }
      }else{
        while (this.$refs[type].childNodes.length > 0) {
          this.$forceUpdate();
          this.$refs[type].removeChild(this.$refs[type].childNodes[0]);
        }
      }
      
    },
    // 折线图
    lineBar(data, id, title) {
      this.$forceUpdate();
      const linePlot = new Line(document.getElementById(id), {
        title: {
          visible: true,
          text: title
        },
        description: {
          visible: true,
          text: "数量"
        },
        padding: "auto",
        forceFit: true,
        data,
        xField: "date",
        yField: "count",
        yAxis: {
          label: {
            // 数值格式化为千分位
            formatter: v =>
              `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, s => `${s},`)
          }
        },
        label: {
          visible: true,
          type: "point"
        },
        point: {
          visible: true,
          size: 5,
          shape: "circle",
          style: {
            fill: "white",
            stroke: "#2593fc",
            lineWidth: 1
          }
        },
        legend: {
          position: "right-top"
        },
        seriesField: "type",
        color: ["#1979C9", "#cccccc"],
        responsive: true
      });
      linePlot.render();
    },
    // 初始化获取数据
    pullData() {
      this.$showLoading();
      getCourseList()
        .then(data => {
          this.bigcourse = data.bigcourse;
          this.courseList = data.list;
          this.getTaList();

          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}
.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages {
  text-align: right;
  margin-top: 30px;
}
.box {
  margin-bottom: 30px;
}
.search {
  display: flex;
  margin-bottom: 20px;
  flex-wrap:wrap;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}
.search-gropu.on {
  flex: 1.5;
}
.search-gropu.btn{
  flex:0.5;
}

.search-child {
  margin-left: 20px;
  width: 150px;
  margin-right: 40px;
}
.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
.qrcode,
.qrcode img {
  width: 100%;
}

.line-bar {
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  .bar-tools {
    margin-left: auto;
    display: flex;
    align-items: center;
    a {
      display: block;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #ccc;
      color: #fff;
      cursor: pointer;
      &:nth-child(1) {
        margin-right: 10px;
      }
    }
    a.on {
      background-color: #409eff;
    }
  }
}

//
.total {
  display: flex;
  border-radius: 5px;
  .total-node {
    flex: 1;
    border: 1px solid #dcdcdc;
    padding: 15px;
    &:nth-child(1) {
      margin-right: 15px;
    }
    h2 {
      margin: 0;
      font-size: 18px;
    }
    h4 {
      font-weight: normal;
      margin: auto;
    }
    h3 {
      margin: auto;
    }
    .total-main {
      display: flex;
      font-size: 16px;
      .ta {
        display: flex;
        flex: 1;
        border: 1px solid #dcdcdc;
        margin-top: 15px;
        .ta-left {
          flex: 1;
          text-align: center;
          display: flex;
          flex-direction: column;
        }
        .ta-right {
          padding: 20px;
          background-color: #409eff;
          display: flex;
          align-items: center;
          img {
            width: 32px;
            height: 32px;
          }
        }
      }
      .stu {
        display: flex;
        flex: 1;
        border: 1px solid #dcdcdc;
        margin-right: 15px;
        margin-top: 15px;
        .stu-left {
          flex: 1;
          text-align: center;
          display: flex;
          flex-direction: column;
        }
        .stu-right {
          padding: 20px;
          background-color: #67c23a;
          display: flex;
          align-items: center;
          img {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
